export const ExtensionMessageType = {
  OPEN_SIDEBAR: "open_sidebar",
  OPEN_TAB: "open_tab",
  SYNC_ORGANIZATION: "sync_organization",
  REQUEST_LOGIN: "request_login",
  LOGOUT: "logout",
  RECONNECT: "reconnect",
  EXECUTE_ACTION: "execute_action",
  EXECUTE_SEQUENCE: "execute_sequence",
  RUN_AUTOMATION: "run_automation",
  APPLY_UPDATE: "apply_update",
} as const;

export type ExtensionMessageTypeValue =
  (typeof ExtensionMessageType)[keyof typeof ExtensionMessageType];
